import IconApplePodcast from "@components/Icon/components/IconApplePodcast";
import IconApply from "@components/Icon/components/IconApply";
import IconCheck from "@components/Icon/components/IconCheck";
import IconClose from "@components/Icon/components/IconClose";
import IconDownArrow from "@components/Icon/components/IconDownArrow";
import IconEmail from "@components/Icon/components/IconEmail";
import IconEnvelope from "@components/Icon/components/IconEnvelope";
import IconFacebook from "@components/Icon/components/IconFacebook";
import IconGlobe from "@components/Icon/components/IconGlobe";
import IconHamburger from "@components/Icon/components/IconHamburger";
import IconHamburgerSearch from "@components/Icon/components/IconHamburgerSearch";
import IconPodcast from "@components/Icon/components/IconHeadphone";
import IconInstagram from "@components/Icon/components/IconInstagram";
import IconLinkedin from "@components/Icon/components/IconLinkedin";
import IconMic from "@components/Icon/components/IconMic";
import IconOpenQuotes from "@components/Icon/components/IconOpenQuotes";
import IconPause from "@components/Icon/components/IconPause";
import IconPlay from "@components/Icon/components/IconPlay";
import IconProfile from "@components/Icon/components/IconProfile";
import IconRightArrow from "@components/Icon/components/IconRightArrow";
import IconRightCaret from "@components/Icon/components/IconRightCaret";
import IconSearch from "@components/Icon/components/IconSearch";
import IconSpotify from "@components/Icon/components/IconSpotify";
import IconSummarise from "@components/Icon/components/IconSummarise";
import IconTelegram from "@components/Icon/components/IconTelegram";
import IconThumbsDown from "@components/Icon/components/IconThumbsDown";
import IconThumbsUp from "@components/Icon/components/IconThumbsUp";
import IconTikTok from "@components/Icon/components/IconTikTok";
import IconTwinkle from "@components/Icon/components/IconTwinkle";
import IconWhatsapp from "@components/Icon/components/IconWhatsapp";
import IconX from "@components/Icon/components/IconX";
import IconYoutube from "@components/Icon/components/IconYoutube";
import { IconProps, IconTypeEnum } from "@components/Icon/utils/types";

const CreateIcon = ({ type }: IconProps): React.ReactElement => {
  switch (type) {
    case IconTypeEnum.close:
      return <IconClose />;

    case IconTypeEnum.facebook:
      return <IconFacebook />;

    case IconTypeEnum.instagram:
      return <IconInstagram />;

    case IconTypeEnum.linkedin:
      return <IconLinkedin />;

    case IconTypeEnum.twitter:
      return <IconX />;

    case IconTypeEnum.telegram:
      return <IconTelegram />;

    case IconTypeEnum.whatsapp:
      return <IconWhatsapp />;

    case IconTypeEnum.email:
      return <IconEmail />;

    case IconTypeEnum.search:
      return <IconSearch />;

    case IconTypeEnum.twinkle:
      return <IconTwinkle />;

    case IconTypeEnum.thumbsUp:
      return <IconThumbsUp />;

    case IconTypeEnum.thumbsDown:
      return <IconThumbsDown />;

    case IconTypeEnum.rightArrow:
      return <IconRightArrow />;

    case IconTypeEnum.hamburger:
      return <IconHamburger />;

    case IconTypeEnum.apply:
      return <IconApply />;

    case IconTypeEnum.hamburgerSearch:
      return <IconHamburgerSearch />;

    case IconTypeEnum.arrowDown:
      return <IconDownArrow />;

    case IconTypeEnum.podcastIcon:
      return <IconMic />;

    case IconTypeEnum.summarise:
      return <IconSummarise />;

    case IconTypeEnum.profile:
      return <IconProfile />;

    case IconTypeEnum.openQuotes:
      return <IconOpenQuotes />;

    case IconTypeEnum.check:
      return <IconCheck />;

    case IconTypeEnum.headphone:
      return <IconPodcast />;

    case IconTypeEnum.rightCaret:
      return <IconRightCaret />;

    case IconTypeEnum.globe:
      return <IconGlobe />;

    case IconTypeEnum.envelope:
      return <IconEnvelope />;

    case IconTypeEnum.tikTok:
      return <IconTikTok />;

    case IconTypeEnum.youtube:
      return <IconYoutube />;

    case IconTypeEnum.pause:
      return <IconPause />;

    case IconTypeEnum.play:
      return <IconPlay />;

    case IconTypeEnum.applePodcasts:
      return <IconApplePodcast />;

    case IconTypeEnum.spotify:
      return <IconSpotify />;

    default:
      return <></>; // Return an empty element if no match found
  }
};

export default CreateIcon;
